import { PlanPaymentForm } from '../PlanPaymentForm';
import { PlanPaymentOnetimeSubmit, PlanPaymentSubmit } from '../PlanPaymentSubmit';
import { PlanPaymentSummary } from '../PlanPaymentSummary';
import { PlanPaymentLayout } from '../shared';
import { PlanTemplateType } from '../types';
import { usePlanPaymentFormContext } from './Providers';
const _KrPlanPaymentContent = () => {
  const {
    watch
  } = usePlanPaymentFormContext();
  const planTemplateType = watch('planTemplateType');
  return <PlanPaymentLayout.Root data-sentry-element="unknown" data-sentry-component="_KrPlanPaymentContent" data-sentry-source-file="KrPlanPaymentContent.tsx">
      <PlanPaymentLayout.Content data-sentry-element="unknown" data-sentry-source-file="KrPlanPaymentContent.tsx">
        <PlanPaymentForm data-sentry-element="PlanPaymentForm" data-sentry-source-file="KrPlanPaymentContent.tsx" />
        <PlanPaymentSummary data-sentry-element="PlanPaymentSummary" data-sentry-source-file="KrPlanPaymentContent.tsx" />
      </PlanPaymentLayout.Content>
      <PlanPaymentLayout.Footer data-sentry-element="unknown" data-sentry-source-file="KrPlanPaymentContent.tsx">
        <div className="w-[990px] min-w-[990px] px-[60px] py-[14px]">
          {planTemplateType === PlanTemplateType.PRODUCT_ONETIME ? <PlanPaymentOnetimeSubmit /> : <PlanPaymentSubmit />}
        </div>
      </PlanPaymentLayout.Footer>
    </PlanPaymentLayout.Root>;
};
export const KrPlanPaymentContent = () => {
  return <_KrPlanPaymentContent data-sentry-element="_KrPlanPaymentContent" data-sentry-component="KrPlanPaymentContent" data-sentry-source-file="KrPlanPaymentContent.tsx" />;
};